import type { AppGlueAny } from "../../Common/AppGlueAny";
import { FlowStepData } from "../Steps/FlowStepData";

export class FlowStepDataRegistrationData {
    type: string;
    name: string;
    initialStepVisible: boolean;
    private prototype: AppGlueAny;

    constructor(type: string, name: string, prototype: AppGlueAny, initialStepVisible: boolean) {
        this.type = type;
        this.name = name;
        this.prototype = prototype;
        this.initialStepVisible = initialStepVisible;
    }

    create(): FlowStepData {
        let flowStep = new this.prototype.constructor();

        flowStep.name = this.name;

        return flowStep;
    }
}

export function RegisterFlowStepData(step: FlowStepData, name: string, initialStepVisible: boolean = false) {
    let prototype = Object.getPrototypeOf(step);

    prototype.__type = step.__type;
    FlowStepDataRegistration.addRegistration(
        new FlowStepDataRegistrationData(step.__type, name, step, initialStepVisible),
    );
}

export class FlowStepDataRegistrationClass {
    private registrations: { [key: string]: FlowStepDataRegistrationData } = {};

    addRegistration(data: FlowStepDataRegistrationData) {
        this.registrations[data.type] = data;
    }

    getByTypeName(typeName: string): FlowStepDataRegistrationData {
        return this.registrations[typeName];
    }

    getAllRegistrations(): { [key: string]: FlowStepDataRegistrationData } {
        return this.registrations;
    }

    getAllRegistrationData(): FlowStepDataRegistrationData[] {
        return Object.values(this.registrations);
    }

    getAllRegistrationNames(): string[] {
        return Object.values(this.registrations).map((v) => v.name);
    }
}

export const FlowStepDataRegistration = new FlowStepDataRegistrationClass();
